var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"orgTree",attrs:{"data":_vm.orgs,"node-key":"id","props":_vm.defaultProps,"default-expand-all":"","expand-on-click-node":false},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }